var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.gatedClass,attrs:{"href":_vm.gatedHref,"target":_vm.target},on:{"click":function($event){_vm.onAction($event, 'click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }